
/*
 * @Descripttion: roi信息
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */
import React, { useRef, useEffect, useContext } from 'react';
import { Radio, Balloon, Icon, Button } from '@alifd/next';
import * as echarts from 'echarts';
import { EChartOption, ECharts } from 'echarts';
import utils from '@/common/utils';
import {ActivityContext} from '../../index';
import CONSTANTS from '../CONSTANTS';
import styles from './index.module.scss';

const { Tooltip } = Balloon;

const renderPieChart = (id, info) => {
  const option: EChartOption = {
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b} : {c} ({d}%)',
    },
    legend: {
      bottom: '0',
      left: 'center',
    },
    color: ['#22CCE2', '#0081FF'],
    series: [
      {
        name: 'ROI（投入产出比）',
        top: -5,
        bottom: 10,
        // name: '昨日订单占比',
        type: 'pie',
        radius: ['40%', '70%'],
        avoidLabelOverlap: false,
        label: {
          show: true,
          position: 'left',
        },
        labelLine: {
          show: true,
        },
        data: [
          { value: info.cost, name: '营销成本/元' },
          { value: info.earnings, name: '营销收益/元' },
        ],
      },
    ],
  };
  const dom = document.getElementById(id);
  if (dom) {
    const chart = echarts.init(dom as HTMLDivElement);
    chart.setOption(option);
    return chart;
  }
  return undefined;
};

const RoiInfo = () => {
  const { ratioTime, changeROITime, roiInfo, setChangePriceDialog } = useContext(ActivityContext);

  const pieChart = useRef<ECharts>();


  const getIndexOrderOverview = async () => {
    const chart = renderPieChart('PieChart', roiInfo);

    pieChart.current = chart;
  };

  const handleResize = () => {
    pieChart.current && pieChart.current.resize();
  };

  useEffect(() => {
    getIndexOrderOverview().then();
  }, [roiInfo]);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [])

  return (
    <div className={styles['roi-info-container']}>
      <Radio.Group
        size='small'
        shape="button"
        dataSource={CONSTANTS.Tab_List}
        value={ratioTime}
        onChange={changeROITime}
        // className="market-effect-radio-group-tab"
      />
      <div className={styles['roi-info-desc']}>
        <Tooltip v2 trigger={<Icon type="help" size={'small'} />} align="t">
          {CONSTANTS.ROI}
        </Tooltip>
        <span>ROI: {roiInfo.roi} </span>
      </div>

      <div id={'PieChart'} style={{ height: 250, width: '100%' }} />

      <div className={styles['data-div']}>
        <div>触达人数/人：{roiInfo.actualNum}</div>
        <div className={styles['flex-div']}>
          <Tooltip v2 trigger={<Icon type="help" size={'small'} />} align="t">
            {CONSTANTS.cost}
          </Tooltip>
          <span>营销成本/元：{utils.numFormat(roiInfo.cost)}</span>
          <span className={styles['btn-span']} onClick={() => setChangePriceDialog(true)}>修改</span>
        </div>
        <div>
          <Tooltip v2 trigger={<Icon type="help" size={'small'} />} align="t">
            {CONSTANTS.earnings}
          </Tooltip>
          <span>营销收益/元：{utils.numFormat(roiInfo.earnings)}</span>
        </div>
      </div>
    </div>
  )
};

export default RoiInfo;
